import {Component} from 'react';
import * as firebase from 'firebase';


const config = {
  apiKey: "AIzaSyBBDjJlJoC3Yef7QRwUWgBO55KitVf-Q80",
  authDomain: "leafletv2.firebaseapp.com",
  databaseURL: "https://leafletv2.firebaseio.com",
  projectId: "leafletv2",
  storageBucket: "leafletv2.appspot.com",
  messagingSenderId: "815120857639"
};

firebase.initializeApp(config);

const storageRef = firebase.storage().ref();

///Stripe should be there, it is in the "public" folder's template
const Stripe = window.Stripe;


/*
//CC test data
{
            number: '4242424242424242',
            cvc: '111',
            exp_month: 1,
            exp_year: 2020,
            address_zip: '00000'
          }
*/

export class FirebaseAPI extends Component{
  constructor(props){
    super(props);
    this.state={
        authenticated: false
    }
  }
  componentWillReceiveProps(nextProps){

    if(nextProps.coffees>this.props.coffees){
      //update firebase
      firebase.database().ref('coffees/'+this.state.user.uid).set({total: nextProps.coffees}).then( ()=>{
        //success
      }).catch((err)=>{
        this.props.onError(err.message, 'requested');
      })
    }

    if(nextProps.loginRequestEmail && nextProps.loginRequestStatus=='requested' && !this.props.authenticated){
      if(nextProps.loginRequestEmail){

      this.signInWithEmailAndPassword(nextProps.loginRequestEmail, nextProps.loginRequestPW).then(()=>{
        //success
        this.props.onLoginRequestStatus(nextProps.loginRequestEmail, nextProps.loginRequestPW, 'completed');
      }).catch((err)=>{
        this.props.onError(err.message, 'requested');
        this.props.onLoginRequestStatus(nextProps.loginRequestEmail, nextProps.loginRequestPW, 'rejected');
      })

      }
    }
    if(nextProps.registerRequestEmail && nextProps.registerRequestStatus=='requested' && !this.props.authenticated){
      console.log("register request at firebaseapi")
      if(nextProps.registerRequestEmail){

      this.createUserWithEmailAndPassword(nextProps.registerRequestEmail, nextProps.registerRequestPW).then(()=>{
        this.props.onRegisterRequestStatus(nextProps.regiserRequestEmail, nextProps.registerRequestPW, 'completed');
      }).catch((err)=>{
        this.props.onError(err.message, 'requested');
        this.props.onRegisterRequestStatus(nextProps.regiserRequestEmail, nextProps.registerRequestPW, 'rejected');
      })

      }
    }
    if(nextProps.logoutRequest ){
      this.signOut().then(()=>{

      }).catch((err)=>{
        this.props.onError(err.message, 'requested');
      })
    }
    if(nextProps.displayName !== this.props.displayName){
      this.setProfile(nextProps.displayName).then(()=>{
        // Update successful.
        this.props.onUser(this.state.user);
      }).catch((err)=>{
        // An error happened.
        this.props.onError(err.message, 'requested');
      });
    }
    if(nextProps.card && !nextProps.cardSubmitted){

      this.submitNewCreditCard(nextProps.card);
    }
    if(nextProps.deleteCard){
      this.removeSource();
    }
    /////this gets called only when the coffee cost is updated.......t.w.
    if(nextProps.userName && nextProps.userName !== this.props.userName){

      this.setUserPrefs({userName: nextProps.userName}).then( ()=>{

      }).catch( (err)=>{
        this.props.onError(err.message, 'requested');
      })
    }
    ////////////////////////////////////////////////////////////////////////
    if(nextProps.fileUpload && nextProps.uploadStatus=="requested"){
      console.log("Got a file upload request");
      this.uploadFile(nextProps.fileUpload);
    }
    if(nextProps.donation && !this.props.donationCompleted){
      this.submitNewCharge(nextProps.donation);
    }
  }
  componentWillMount(){
    this.initAuthentication();
  }
  createUserWithEmailAndPassword(email, password){
      //this should just update data
    return firebase.auth().createUserWithEmailAndPassword(email, password);
  }
  signOut(){
      //this should just update data
    return firebase.auth().signOut();
  }

  signInWithEmailAndPassword(email, password){
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }
  setProfile(displayName){
    return this.state.user.updateProfile({
      displayName: displayName
    });
  }
  setUserPrefs(prefs){
    prefs.email = this.state.user.email;
    return firebase.database().ref(`/pref_requests/${this.state.user.uid}/prefs`).set(prefs);//request handled by cloud function
  }

  ///File Uploads//////////////////////////////////////////////////////////////////
  uploadFile(fileToUpload){
    console.log("I will upload a file");
    console.log(fileToUpload);
    //upload the file
    //get the url of the upload
    //update the user information

    const metadata = {
      contentType: fileToUpload.type
    }
    this.props.onUploadStatus(fileToUpload, "starting");

    const avatarRef = storageRef.child('images/'+this.state.user.uid+'/'+fileToUpload.name);
    const uploadTask = avatarRef.put(fileToUpload, metadata);


    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot)=>{
      let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      this.props.onUploadProgress(progress);
      console.log("state is: "+snapshot.state);
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED:
          console.log('Upload is paused');
          break;
        case firebase.storage.TaskState.RUNNING:
          console.log('Upload is running');
          break;
        case firebase.storage.TaskState.SUCCESS:
          console.log('Upload is completed');
          this.props.onUploadStatus(fileToUpload, "completed");
          break;
      }
    }, (err)=>{
      console.log("Error on upload....")
    }, ()=>{
      console.log("Completed....");
      //console.log( storageRef.child('images/'+fileToUpload.name).name );
      avatarRef.getDownloadURL().then((url)=>{
        console.log("Url is "+url);
        this.state.user.updateProfile({
          photoURL: url
        }).then(()=>{
          console.log("photo url set for user")
          this.props.onUser(this.state.user, "updated");
        }).catch((err)=>{
          console.log("Error setting photo url");
          console.log(err);
        })
      })
    })
  }
  ///Ecommerce Integration/////////////////////////////////////////////////////////
  submitNewCreditCard(cardInfo){
    Stripe.card.createToken({
                number: cardInfo.card,
                cvc: cardInfo.cvc,
                exp_month: cardInfo.exp_month,
                exp_year: cardInfo.exp_year,
                address_zip: cardInfo.zip
              }, (status, response) => {
                if (response.error) {
                  this.props.onError(response.error, 'requested');
                } else {
                  firebase.database().ref(`/stripe_customers/${this.state.user.uid}/sources`).push({token: response.id}).then( () => {

                  }).catch( (err)=>{
                    this.props.onError(err.message, 'requested');
                  })
                }
              });
  }
  submitNewCharge(amount){
    firebase.database().ref(`/stripe_customers/${this.state.user.uid}/charges`).push({
              source: this.state.source,
              amount: parseInt(Math.floor(amount*100) )
            }).then( ()=>{
              this.props.onDonationComplete();//this makes more donations possible?
            }).catch( (err)=>{
              this.props.onError(err.message, 'requested');
            })
  }
  removeSource(){
    firebase.database().ref(`/stripe_customers/${this.state.user.uid}/sources`).remove().then( ()=>{
      //issue a deleteCard false now the action is completed
      this.props.onDeleteCard();
    })
  }
///////////////////////////////////////////////////////

  ///listen for auth changes in firebase
  initAuthentication(){
      const connectedRef = firebase.database().ref('.info/connected');
      connectedRef.on("value", (snap)=> {
      if (snap.val() === true) {
        this.setState({connected:true},()=>{
          this.props.onOnlineStatusChange(true);
          
        })
      } else {
        this.setState({connected:false},()=>{
          this.props.onOnlineStatusChange(false);
        })
      }
    });

//////////////////////////////////////////////////
    //is this triggered by profile info changes for the user??
    firebase.auth().onAuthStateChanged(

      user=>{
        console.log("The user is:::")
        console.log(user);
        
        if(user){
          try{
            Stripe.setPublishableKey( 'pk_test_mPEIYmwbefiEW5L3IEfARjG0' );
          } catch(err){
            console.log("Some error setting publish key, probably offline");
          }
          
          this.setState({
            authenticated: true,
            user: user
          },()=>{
            this.props.onAuthenticationChange(true)
            this.props.onUser(user);
            this.initDataTracking();
          })
        }else{
          this.setState({
            authenticated: false
          }, ()=>{
            this.props.onAuthenticationChange(false);
            this.props.onUser({});
 
          })
        }
        
      }
    )
  }

  initDataTracking(){
    //stats data
    firebase.database().ref('stats').on('value', snapshot =>{
      //got data created by the cron job....
      console.log("STATS DATA");
      console.log(snapshot.val() );
      this.props.onStats( snapshot.val() );
    })
    //coffee data
    firebase.database().ref('coffees/'+this.state.user.uid).on('value', snapshot =>{
      const dbTotal = Number(snapshot.val() ? snapshot.val().total : 0 );//could be null if no coffees tracked

    })
    //preferences data
    firebase.database().ref('users/'+this.state.user.uid).on('value', snapshot =>{
      if(snapshot){
        console.log("User preferences::");
        console.log(snapshot.val() );
        this.props.onUserPrefs( snapshot.val() );//this now contains userName
      }
    })
    //credit card data
    firebase.database().ref('stripe_customers/'+this.state.user.uid+'/sources').limitToFirst(1).on('value', snapshot =>{

      if(snapshot){
        //the call below assumes support for a single credit card
        //id in 'source' is assigned by stripe
        if(snapshot.val() ){
        const firstCard = snapshot.val()[ Object.keys(snapshot.val())[0] ];

          this.setState({
            source: firstCard.id
          },()=>{
            //add a card to the user Object
            //note cvc, zip and full card number not includeds

            const card={
              lastFour: firstCard.last4,
              exp_month: firstCard.exp_month,
              exp_year:firstCard.exp_year,
              brand:firstCard.brand
            }

            this.setState({card:card}, ()=>{
              this.props.onUserCard(this.state.card);
            })



          })

        //end of if snapshot val
      }else{
        //card was removed, sources null
        this.props.onUserCard(null);
      }


      }
    })
    //charges listener
    firebase.database().ref('stripe_customers/'+this.state.user.uid+'/charges').on('value', (snapshot)=>{
      if(snapshot){
        ///total up number of successful charges
        let numCharges, chargeTotal = 0;

        const allCharges = snapshot.val();
        try{
        const chargeNames = Object.keys(allCharges);
         numCharges = chargeNames.length || 0;


          chargeTotal = chargeNames.reduce((sum, name)=>{
            return sum+allCharges[name].amount;
          },0)
        }
        catch(e){
          //no charges (most likely)
          numCharges =0;
        }
        //callback the container to issue action
        this.props.onCharges({
          totalNumber: numCharges,
          totalAmount: chargeTotal
        })
      }
    })

  }

  render(){
    return(
    null
    )
  }
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/firebaseAPI.js